export const fr = {
  title: `Les impacts sur les enfants`,
  school: `École`,
  psychosocial: `Psychosocial`,
  enternaining: `Divertissements`
};
